import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import { useRef } from "react";
import { useCoveoHooks } from "../Contexts/CoveoHooksContext";

const useCoveoSearch = () => {
    const history = useHistory();
    const { searchBox } = useCoveoHooks();
    const searchInputRef = useRef<HTMLInputElement | null>(null);

    const doCoveoSearch = (query: string) => {
        searchBox.methods?.updateText(query);
        const isNoResultsPage = window.location.pathname === "/no-results";
        if (isNoResultsPage) {
            window.location.href = `/search?q=${query}`;
        } else {
            history.push(`/search?q=${query}`);
        }
    };

    const clearCoveoSearch = () => {
        searchBox.methods?.clear();
        searchInputRef.current?.blur();
    };

    return {
        searchInputRef,
        doCoveoSearch,
        clearCoveoSearch,
    };
};

export default useCoveoSearch;
